import React from "react";

function CloudStoreIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#000"
        d="M14.625 16.554H12.89v-5.679a.188.188 0 00-.188-.188h-1.406a.188.188 0 00-.188.188v5.679H9.375a.187.187 0 00-.147.302l2.625 3.321a.186.186 0 00.23.053.185.185 0 00.065-.053l2.625-3.32a.187.187 0 00-.148-.303z"
      ></path>
      <path
        fill="#000"
        d="M19.017 8.595a7.503 7.503 0 00-7.012-4.845 7.5 7.5 0 00-7.013 4.842A4.69 4.69 0 001.5 13.125a4.686 4.686 0 004.685 4.688h.94a.188.188 0 00.188-.188v-1.406a.188.188 0 00-.188-.188h-.94a2.905 2.905 0 01-2.29-4.697c.392-.499.94-.862 1.55-1.024l.888-.232.326-.858a5.756 5.756 0 012.065-2.655 5.675 5.675 0 013.28-1.036c1.184 0 2.319.359 3.282 1.036A5.762 5.762 0 0117.35 9.22l.323.856.886.234a2.92 2.92 0 012.159 2.815 2.89 2.89 0 01-.851 2.056 2.884 2.884 0 01-2.053.85h-.94a.188.188 0 00-.188.188v1.406c0 .103.085.188.188.188h.94a4.688 4.688 0 001.202-9.218z"
      ></path>
    </svg>
  );
}

export default CloudStoreIcon;
